import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/enter_icon.svg'
import _imports_1 from '@/assets/img/bg3.png'
import _imports_2 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-35ed67d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pro-home-page overflow-x-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "col-sm-12 col-md-12 row my-auto no-padding no-margin" }
const _hoisted_4 = {
  class: "col-sm-12 col-12 col-md-12 row no-padding no-margin",
  style: {"align-items":"center"}
}
const _hoisted_5 = { class: "col-sm-12 col-md-4 offset-md-2 text-container tab-container no-padding flex-container" }
const _hoisted_6 = { class: "left-content" }
const _hoisted_7 = {
  id: "content-sec1",
  class: "content-sec1"
}
const _hoisted_8 = { class: "content-sec2" }
const _hoisted_9 = {
  key: 0,
  class: "display-flex m-top-47 passphrase content-sec3"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { for: "passphrase" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 1,
  class: "content-sec4"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "display-flex m-top-47 content-sec3" }
const _hoisted_16 = {
  key: 0,
  class: "content-sec2-enter-block d-sm-none d-md-block d-none d-sm-block"
}
const _hoisted_17 = { class: "enter-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "enter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6 tab-image-container flex-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img-laptop"
  })
], -1))
const _hoisted_20 = { class: "footer row d-sm-none d-md-block d-none d-sm-block page-footer no-margin" }
const _hoisted_21 = { href: "https://cybersystem.io" }
const _hoisted_22 = {
  id: "prospectModal",
  class: "modal fade prospect-form",
  tabindex: "-1",
  "data-bs-backdrop": "false",
  "data-bs-keyboard": "false"
}
const _hoisted_23 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-close float-right" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "close",
      "data-bs-dismiss": "modal",
      "data-bs-target": "#prospectModal"
    }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
    ])
  ])
], -1))
const _hoisted_26 = { class: "modal-body" }
const _hoisted_27 = { class: "modal-body-padding" }
const _hoisted_28 = { class: "modal-welcome" }
const _hoisted_29 = { class: "modal-sec2" }
const _hoisted_30 = { class: "modal-sec3" }
const _hoisted_31 = { class: "form-group proEmail" }
const _hoisted_32 = { for: "proEmail" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = ["v-if"]
const _hoisted_35 = { class: "form-group proDomain" }
const _hoisted_36 = { for: "proDomain" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = ["v-if"]
const _hoisted_39 = { class: "modal-sec4" }
const _hoisted_40 = { class: "modal-sec5" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "loader"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1))
const _hoisted_44 = { class: "spinner-text" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "modal-footer" }
const _hoisted_47 = { class: "modal-sec6" }
const _hoisted_48 = { class: "modal-sec6-sec1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerlogo = _resolveComponent("headerlogo")!
  const _component_errorhandler = _resolveComponent("errorhandler")!
  const _component_v_runtime_template = _resolveComponent("v-runtime-template")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_headerlogo, {
        "page-type": '1',
        "csrf-loaded": true,
        "show-prospect-form": _ctx.showProspectForm
      }, null, 8, ["show-prospect-form"]),
      _createElementVNode("div", {
        class: "row no-padding main-body h-100",
        style: _normalizeStyle({ height: _ctx.windowHeight })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getUiText("app-prospect-landing-heading-1")), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getUiText("app-prospect-landing-heading-sub-1")), 1),
                (_ctx.isFailVerified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.getUiText("app-prospect-landing-preview-heading-1")), 1),
                        _withDirectives(_createElementVNode("input", {
                          id: "passphrase",
                          ref: "passphraseCodeFeild",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passphrase) = $event)),
                          "data-cy": "psp-home-passphrase-input",
                          type: "text",
                          autocomplete: "false",
                          class: "form-control",
                          placeholder: _ctx.passphrasePrompt,
                          tabindex: "0"
                        }, null, 8, _hoisted_12), [
                          [_vModelText, _ctx.passphrase]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isFailVerified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.getUiText("app-prospect-landing-preview-tip-1")), 1))
                  : _createCommentVNode("", true),
                (
                    !_ctx.isFailVerified ||
                    (_ctx.isFailVerified && (_ctx.passphraseStatus || null))
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("button", {
                          id: "letsgo",
                          "data-cy": "psp-home-letsgo-btn",
                          type: "button",
                          class: "btn btn-primary letsgo-button",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.letsgo && _ctx.letsgo(...args)))
                        }, _toDisplayString(_ctx.getUiText("app-prospect-landing-button-lets-go-1")), 1),
                        (_ctx.isFailVerified)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getUiText("app-nav-press-enter-1")), 1),
                              _hoisted_18
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_19
          ])
        ])
      ], 4),
      _createElementVNode("div", _hoisted_20, [
        _createTextVNode(_toDisplayString(_ctx.getUiText("app-prospect-nav-cms-text-1")) + " ", 1),
        _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.getUiText("app-prospect-nav-cms-link-1")), 1)
      ])
    ]),
    (_ctx.showProspectCallbackError || null)
      ? (_openBlock(), _createBlock(_component_errorhandler, {
          key: 0,
          "prospect-callback-error-msg": _ctx.prospectCallbackErrorMsg,
          onResetShowProspectCallbackError: _ctx.resetShowProspectCallbackError
        }, null, 8, ["prospect-callback-error-msg", "onResetShowProspectCallbackError"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.getUiText("app-prospect-landing-verify-heading-1")), 1),
              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getUiText("app-prospect-landing-verify-heading-sub-1")), 1),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.getUiText("app-prospect-landing-verify-email-heading-1")), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "proEmail",
                      ref: "proEmail",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.prospectData.email) = $event)),
                      "data-cy": "psp-home-email",
                      type: "email",
                      autocomplete: "false",
                      class: _normalizeClass(["form-control", !_ctx.emailValid ? 'invalid-input' : '']),
                      placeholder: _ctx.emailPrompt,
                      tabindex: "0",
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.prospectFormOnKeyUp && _ctx.prospectFormOnKeyUp(...args)), ["enter"])),
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputBlur('EMAIL')))
                    }, null, 42, _hoisted_33), [
                      [_vModelText, _ctx.prospectData.email]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-msg", !_ctx.emailValid ? 'mg-top-19' : '']),
                      "v-if": !_ctx.emailValid || null
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.emailValidationMsg), 1)
                    ], 10, _hoisted_34)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.getUiText(
                          "app-prospect-landing-verify-domain-heading-1",
                        )), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "proDomain",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prospectData.org_domain) = $event)),
                      "data-cy": "psp-home-domain",
                      type: "domain",
                      autocomplete: "false",
                      class: _normalizeClass(["form-control", !_ctx.domainValid ? 'invalid-input' : '']),
                      placeholder: 
                        _ctx.getComponentUiText(
                          'app-prospect-landing-verify-domain-prompt-1',
                        )
                      ,
                      onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.prospectFormOnKeyUp && _ctx.prospectFormOnKeyUp(...args)), ["enter"])),
                      onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.inputBlur('DOMAIN')))
                    }, null, 42, _hoisted_37), [
                      [_vModelText, _ctx.prospectData.org_domain]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-msg", 
                        !_ctx.domainValid || _ctx.domainValidationMsg ? 'mg-top-25' : ''
                      ]),
                      "v-if": !_ctx.domainValid || _ctx.domainValidationMsg !== '' || null
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.domainValidationMsg), 1)
                    ], 10, _hoisted_38)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.getUiText("app-prospect-landing-verify-email-domain-match-1")), 1),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("button", {
                  type: "button",
                  "data-cy": "psp-home-getstarted-button",
                  class: _normalizeClass(["btn btn-primary getstarted-button", _ctx.loader ? 'disable-click' : '']),
                  disabled: _ctx.disableButton,
                  tabindex: "3",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveProspect && _ctx.saveProspect(...args)))
                }, [
                  (_ctx.loader || null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.getUiText("app-nav-button-loading-text")) + "...", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.getUiText(
                      "app-prospect-landing-verify-button-get-started-1",
                    )), 1))
                ], 10, _hoisted_41)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_v_runtime_template, { template: _ctx.footerText }, null, 8, ["template"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}